import * as Sentry from "@sentry/browser";
import usuarioApi from "../../api/usuario";
import * as types from "../mutation-types";
import { actions as assinaturaActions } from "./actions/assinatura";

// initial state
const state = {
  user: {},
  cidadeIp: {},
  cartao: {},
  navbarMessages: [],
  invoices: []
};

// getters
const getters = {
  userPlan: state => {
    if (typeof state.user.dados_assinatura !== "undefined") {
      return state.user.dados_assinatura.detalhes_plano.nome;
    }
    return "";
  }
};

// actions
const actions = {
  lerNotificacao({ commit }, notificacao) {
    commit(types.LER_NOTIFICACAO, notificacao);
    return usuarioApi.lerNotificacao(notificacao.id);
  },
  lerTodasNotificacoes({ commit }) {
    commit(types.LER_TODAS_NOTIFICACOES);
    return usuarioApi.lerTodasNotificacoes();
  },
  visualizarTodasNotificacoes({ commit }) {
    if (state.user.quantidade_notificacoes_nao_visualizadas) {
      commit(types.VISUALIZAR_TODAS_NOTIFICACOES);
      usuarioApi.visualizarTodasNotificacoes();
    }
    return Promise.resolve();
  },
  tornarBeta({ commit }) {
    return usuarioApi.tornarBeta().then(data => {
      commit(types.SET_USUARIO, data);
    });
  },
  getAuthUser({ commit }) {
    return usuarioApi.getAuthUser(data => {
      commit(types.SET_USUARIO, data);
      if (data.confirmed === 0) {
        const message = `Você ainda não confirmou seu e-mail. Clique aqui para resolver.`;
        const link = "#";
        const routeName = "email";
        commit(types.SET_MESSAGES, { message, link, routeName });
      }

      Sentry.configureScope(scope => {
        scope.setUser({
          id: data.id,
          email: data.email
        });
      });
    });
  },
  checkIfAuthenticated({ commit }) {
    return new Promise((resolve, reject) => {
      usuarioApi.checkIfAuthenticated().then(({ data }) => {
        console.log(data);
        if (data.status === "authenticated") {
          resolve();
        }
        reject();
      });
    });
  },
  cidadePorIp({ commit }) {
    return usuarioApi.cidadePorIp().then(({ data }) => {
      commit(types.SET_CIDADE_IP, data.cidade);
      return data;
    });
  },
  cadastrarUsuario({ commit }, payload) {
    return usuarioApi.cadastrarUsuario(payload).then(({ data }) => {
      commit(types.SET_USUARIO, data.usuario);
    });
  },
  enviarMensagem({ commit }, payload) {
    return usuarioApi.enviarMensagem(payload).then(({ data }) => {});
  },
  doLogin({ commit }, payload) {
    return usuarioApi.doLogin(payload).then(data => {
      if (
        typeof data.data !== "undefined" &&
        typeof data.data.usuario !== "undefined"
      ) {
        commit(types.SET_USUARIO, data.data.usuario);
      }
      return data;
    });
  },
  updateUsuario({ commit }, payload) {
    return usuarioApi.update(state.user.id, payload).then(({ data }) => {
      commit(types.SET_USUARIO, data);
    });
  },
  registrarAcao({ commit }, payload) {
    return usuarioApi.registrarAcao(payload);
  },
  somarQuantidadeDuvidas({ commit }) {
    commit(types.SOMAR_QUANTIDADE_DUVIDAS);
    return Promise.resolve();
  }
};

// mutations
const mutations = {
  [types.SET_USUARIO](state, usuario) {
    state.user = usuario;
  },
  [types.VISUALIZAR_NOTIFICACOES](state, monitoramentoId) {
    const notificacoes = state.user.ultimas_notificacoes_monitoramento || [];
    notificacoes.forEach(n => {
      if (n.data.monitoramento.id === monitoramentoId) {
        n.read_at = new Date().getTime();
      }
    });
  },
  [types.SET_MESSAGES](state, { message, link, routeName, action }) {
    state.navbarMessages.push({ message, link, routeName, action });
  },
  [types.UNSET_MESSAGE](state, message) {
    state.navbarMessages = state.navbarMessages.filter(m => m !== message);
  },
  [types.SET_CIDADE_IP](state, cidade) {
    state.cidadeIp = cidade;
  },
  [types.LER_NOTIFICACAO](state, notificacao) {
    notificacao.read_at = new Date().getTime();
  },
  [types.VISUALIZAR_TODAS_NOTIFICACOES](state) {
    state.user.quantidade_notificacoes_nao_visualizadas = 0;
  },
  [types.LER_TODAS_NOTIFICACOES](state, notificacao) {
    state.user.ultimas_notificacoes_monitoramento.forEach(n => {
      n.read_at = new Date().getTime();
    });
  },
  [types.SET_FATURAS](state, faturas) {
    state.invoices = faturas;
  },
  [types.SOMAR_QUANTIDADE_DUVIDAS](state) {
    state.user.quantidade_duvidas_processos += 1;
  }
};

export default {
  state,
  getters,
  actions: {
    ...actions,
    ...assinaturaActions
  },
  mutations
};
